import { render, staticRenderFns } from "./depositTier.vue?vue&type=template&id=2612e714&lang=pug"
import script from "./depositTier.vue?vue&type=script&lang=js"
export * from "./depositTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports